import React from 'react';
import { Switch, Route } from 'react-router-dom'
import LandingPage from './LandingPage';
import Main from './Main';


const Routing = () => (
		<div>
  			<Switch>
  				<Route exact path="/" component={LandingPage} />
  				<Route path="/LandingPage" component={LandingPage} />
    			<Route path="/Main" component={Main} />
  			</Switch>
  		</div>
)

export default Routing;
